import { queryClient } from '../../../../v4/migration/queryClientSingleton';
import { myV1ActionEvent } from '../../../../v4/migration/actionAsEventMiddleware.connected';
import { myCalloutsApi } from '../../../api/callouts/callouts.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createCalloutsService } from './CalloutsService.impl';

export const myCalloutsService = createCalloutsService({
  api: myCalloutsApi,
  queryClient,
  v1Event: myV1ActionEvent,
  services: {
    messageService: myMessageService,
    errorService: myErrorService
  }
});
